angular.module('tradersyard').controller('blacklist-widget-ctrl', [
    '$scope',
    '$timeout',
    function ($scope, $timeout) {
        $scope.node = $scope.$parent.node;
        $scope.$promote = false;

        $scope.promote = function () {
            $scope.$promote = !$scope.$promote;
            $timeout(function () {
                var input = document.getElementById('search');
                if (input) {
                    input.focus();
                }
            });
        };
    },
]);
